import { render, staticRenderFns } from "./consultant.vue?vue&type=template&id=cd05ecf8&scoped=true&"
import script from "./consultant.vue?vue&type=script&lang=js&"
export * from "./consultant.vue?vue&type=script&lang=js&"
import style0 from "./consultant.vue?vue&type=style&index=0&id=cd05ecf8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd05ecf8",
  null
  
)

export default component.exports